import React, { useState, useEffect } from "react";
import { setReminderOndemand } from "../../../services/medium";
import { toast } from "react-toastify";
import moment from "moment";
import { useSelector } from "react-redux";
import { use } from "react";

export default function BookAppointmentPopUp({
  directAppMediumInfo,
  booKGroupEvent,
  isWorker=0
}) {
  const [value, setValue] = useState("");
  const [error, setError] = useState(false);
  const { timezone_name } = useSelector((state) => state.user.user);
  //  const [isWorker, setIsWorker] = useState(false);
  useEffect(() => {
   console.log(directAppMediumInfo, "directAppMediumInfo");
  }, [directAppMediumInfo]);

  const currentUserDate = (day) => moment(day, 'YYYY-MM-DD').format("dddd, MMMM DD, YYYY");
  const { medium_name = "", fullday = "", backupdate = '', title = "",time = "", ondemand_session_category_id,subtext = "" } = directAppMediumInfo

  return (
    <div>
      <div
        id="BookAppointmentPopUp"
        class="modal fade bd-example-modal-lg mt-5 preview-modal-availability"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      // data-backdrop="static"
      >
        <div class="modal-dialog modal-lg modal-dialog-preview text-center">
          <div class="modal-content p-5 ">
            <div className="cross-icon-popup">
              <img
                onClick={() =>
                  window.loadModal2("#BookAppointmentPopUp", "hide")
                }
                src="localImages/crossicon.png"
              />
            </div>
            {ondemand_session_category_id == "101" && isWorker == 1 && (
            <p className="font-size-24 line-height-36px">
              Please confirm that you want to serve as a medium in this{" "}
               {
                            ondemand_session_category_id == "96" ? "Community Support Groups" :
                            ondemand_session_category_id == "95" ? "speaker event" :
                            title === "Group Coaching" ? "group" :
                            ondemand_session_category_id == "94" ? "coached practice circle" :
                            ondemand_session_category_id == "99" ? "Mediumship Platform Demonstration - Practice" :
                            ondemand_session_category_id == "101" ? "Professional Demonstration" :
                            "practice circles"
                          } 
                          {/* {ondemand_session_category_id != "95" ? "session with" : "session " } */}
                          
              {/* <br />
              <b className="text-underline"> {ondemand_session_category_id != "95" ? medium_name : subtext}&nbsp; </b> */}
              {" "}on
              <br />
              <b className="text-underline"> {currentUserDate(backupdate)} </b> at <b className="text-underline"> {time} </b>?
            </p>
            )}
            {ondemand_session_category_id == "101" && isWorker == 0 && (
            <p className="font-size-24 line-height-36px">
              Please confirm you want to select the{" "}
               {
                            ondemand_session_category_id == "96" ? "Community Support Groups" :
                            ondemand_session_category_id == "95" ? "speaker event" :
                            title === "Group Coaching" ? "group" :
                            ondemand_session_category_id == "94" ? "coached practice circle" :
                            ondemand_session_category_id == "99" ? "Mediumship Platform Demonstration - Practice" :
                            ondemand_session_category_id == "101" ? "Professional Demonstration" :
                            "practice circles"
                          } 
                          {/* {ondemand_session_category_id != "95" ? "session with" : "session " } */}
                          
              {/* <br />
              <b className="text-underline"> {ondemand_session_category_id != "95" ? medium_name : subtext}&nbsp; </b> */}
             {" "} on
           
              <b className="text-underline"> {currentUserDate(backupdate)} </b> at <b className="text-underline"> {time} </b>?
            </p>
            )}
            {ondemand_session_category_id != "101" && (
            <p className="font-size-24 line-height-36px">
              Please confirm if you <br />
              {console.log(title, "title")}
              want to book {
                            ondemand_session_category_id == "96" ? "Community Support Groups" :
                            ondemand_session_category_id == "95" ? "speaker event" :
                            title === "Group Coaching" ? "group" :
                            ondemand_session_category_id == "94" ? "coached practice circle" :
                            ondemand_session_category_id == "99" ? "Mediumship Platform Demonstration - Practice" :
                            ondemand_session_category_id == "101" ? "Professional Demonstration" :
                            "practice circles"
                          } {ondemand_session_category_id != "95" ? "session with" : "session " }
              <br />
              <b className="text-underline"> {ondemand_session_category_id != "95" ? medium_name : subtext}&nbsp; </b>
              on
              <b className="text-underline"> {currentUserDate(backupdate)} </b>?
            </p>
            )}
                  {/* <div className="worker-checkbox-section"
            >
              <input
                type="checkbox"
                id="workerCheckbox"
                checked={isWorker}
                onChange={(e) => setIsWorker(e.target.checked)}
                style={{ marginRight: "8px" }}
              />
              <p htmlFor="workerCheckbox" className="font-size-24" style={{ margin: 0 }}>
                I wish to attend this session as a worker.
              </p>
            </div> */}
            <form className="mt-5" id="msform">
              <div className="mt-2 ml-4 mr-4 d-flex justify-content-center align-items-center choose-medium">
                <button
                  type="button"
                  onClick={() =>
                    window.loadModal2("#BookAppointmentPopUp", "hide")
                  }
                  className="previous action-button-previous float-right width-unset pl-4 pr-4 mr-5 color-d5a67b color-d5a67b-qw"
                >
                  No
                </button>

                <button
                  type="button"
                  onClick={booKGroupEvent}
                  className={`next action-button float-left margin-unset`}
                >
                  {"Yes"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
